<template>
  <div v-cloak>
    <div class="vx-card">
      <loading v-if="showLoading"></loading>
      <div class="vx-card__body card-body">
        <div class="vx-row flex justify-end px-4">
          <div class="flex w-full justify-end gap-4 items-end flex-wrap">
            <div class="flex items-end flex-wrap">
              <div>
                <label class="custom-file-upload">
                  <input
                    type="file"
                    id="file"
                    ref="file"
                    v-on:change="handleFileUpload()"
                  />

                  <feather-icon
                    icon="PaperclipIcon"
                    svgClasses="h-4 w-4"
                    class="ico"
                  />
                  <span v-if="!uploadedFileName" class="pr-1">{{
                    $t("ChooseFile")
                  }}</span>

                  <span v-if="uploadedFileName" class="file-name">{{
                    uploadedFileName
                  }}</span>
                </label>
              </div>
              <div class="flex flex-no-wrap items-end">
                <date-picker
                  v-if="fileUploaded"
                  v-model="chargeExpireDate"
                  type="datetime"
                  format="jYYYY-jMM-jDD HH:mm:ss"
                  display-format="jYYYY-jMM-jDD HH:mm"
                  class="date-picker"
                  :label="$t('ExpirationDate')"
                  :clearable="true"
                />
                <vs-button
                  @click="uploadFile()"
                  class="bg_m_green float-right whitespace-no-wrap"
                  v-if="fileUploaded"
                  :disabled="disabledBtn || !chargeExpireDate.length"
                >
                  <feather-icon
                    icon="PlusIcon"
                    svgClasses="h-4 w-4"
                    class="ico"
                  />
                  {{ $t("UploadFile") }}
                </vs-button>
              </div>
            </div>
            <div class="flex">
              <div class="w-full">
                <vs-button
                  @click="showFilters = !showFilters"
                  class="bg_purple float-right whitespace-no-wrap"
                  ><div class="px-3">
                    <feather-icon
                      icon="FilterIcon"
                      svgClasses="h-4 w-4"
                      class="ico"
                    />
                    {{ $t("Filter") }}
                  </div>
                </vs-button>
              </div>
            </div>
          </div>
        </div>
        <div class="vx-row flex justify-start px-4" v-if="showFilters">
          <div class="md:w-1/2 w-full">
            <div class="flex gap-4">
              <div class="w-full">
                <label class="vs-select--label">{{ $t("Search") }}</label>
                <vs-input
                  name="user"
                  :placeholder="
                    $t('AbilitySearchCompanyName_firstName_lastName_code')
                  "
                  class=""
                  v-model="gridSearchData.keyword"
                  @keyup.enter="search()"
                  v-trim-space
                />
              </div>
              <div>
                <vs-button
                  class="mt-6 p-2"
                  color="success"
                  type="gradient"
                  icon-pack="feather"
                  icon="icon-search"
                  @click.prevent="search()"
                ></vs-button>
              </div>
            </div>
          </div>
        </div>
        <div class="vx-row pt-4">
          <div class="vx-col w-full mb-base">
            <data-grid
              ref="grid"
              stripe
              :pageSizeManual="pageSizeManual"
              :data-source="gridDataSource"
              :search-data="gridSearchData"
              :columns="[
                { title: $t('AgentName') },
                { title: $t('Reason') },
                { title: $t('CreateOn') },
                { title: $t('ExpirationDate') },
                { title: $t('Action') },
              ]"
            >
              <template slot-scope="{ row, pagination }">
                <td style="width: 30%">
                  {{ row.saleAgentInfoQuery.firstName }}
                  {{ row.saleAgentInfoQuery.lastName }}
                  {{ row.saleAgentInfoQuery.companyName }}
                </td>
                <td style="width: 15%">
                  <span v-if="row.reason == 1">
                    {{ $t("Excel") }}
                  </span>
                  <span v-if="row.reason == 2">
                    {{ $t("Ui") }}
                  </span>
                  <span v-if="row.reason == 3">
                    {{ $t("SaleAgentDraftOrderRejected") }}
                  </span>
                  <span v-if="row.reason == 4">
                    {{ $t("SaleAgentDraftOrderCreated") }}
                  </span>
                  <span v-if="row.reason == 5">
                    {{ $t("DraftOrderRejected") }}
                  </span>
                  <span v-if="row.reason == 6">
                    {{ $t("DraftOrderCreated") }}
                  </span>
                </td>
                <td style="width: 20%; direction: ltr">
                  {{ row.persianDateTime }}
                </td>
                <td style="width: 15%; direction: ltr">
                  {{
                    row.persianExpirationClock
                      ? row.persianExpirationClock
                      : "-"
                  }}
                </td>
                <td style="width: 20%">
                  <router-link
                    :to="{
                      path: '/Quotas/Details/' + row.id,
                      query: {
                        quotaTransactionType: 1,
                        numberRowsPerPage: pagination.pageSize,
                        tabIndex: tabIndex,
                      },
                    }"
                    style="direction: rtl"
                  >
                    <vs-button
                      color="primary"
                      type="border"
                      icon-pack="feather"
                      icon="icon-eye"
                      class="custom-border-btn mr-4"
                      v-has-permission="permission50"
                      >{{ $t("Details") }}</vs-button
                    >
                  </router-link>
                </td>
              </template>
            </data-grid>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
input[type="file"] {
  display: none;
}
.custom-file-upload {
  border: 1px solid #ccc;
  display: inline-block;
  padding: 4px 12px 4px 12px;
  cursor: pointer;
}
.bg_m_green {
  border-radius: 6px 0 0 6px !important;
  padding: 0.3rem 0.8rem !important;
}
.file-name {
  padding: 0 0.5rem;
  background-color: #eeeff1;
  position: relative;
  left: -0.65rem;
}

.date-picker ::v-deep input {
  height: 32px !important;
  width: 200px !important;
  border-radius: 0rem !important;
  direction: ltr;
}
.date-picker ::v-deep label {
  height: 32px !important;
  display: flex;
  gap: 3px;
  border-radius: 0rem !important;
  direction: ltr;
  width: 110px !important;
}
::v-deep .date-picker {
  width: 230px !important;
}
</style>

<script>
import { mapActions } from "vuex";
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import Loading from "@/components/loading/Loading.vue";

export default {
  name: "saleManagement_Quotas_Charge",
  components: {
    DataGrid,
    Loading,
  },
  props: {
    tabIndex: { default: 1 },
    numberRowsPerPage: {
      default: -1,
    },
  },
  data() {
    return {
      showFilters: false,
      testStr: "این فایل تکراری است.\n آیا از بارگزاری مجدد اطمینان دارید؟",
      isConfirmDuplicateData: false,
      permission50: "",
      ModifyPopup: false,
      modalModel: {},
      pageSizeManual: 10,
      gridDataSource: { data: [] },
      gridSearchData: {
        quotaTransactionType: "1",
        keyword: "",
      },
      file: "",
      fileUploaded: false,
      disabledBtn: false,
      showLoading: false,
      uploadedFileName: "",
      emptyFileInRefs: "",
      chargeExpireDate: "",
    };
  },
  mounted() {
    this.pageSizeManual = this.numberRowsPerPage ? this.numberRowsPerPage : -1;
    this.gridDataSource = {
      type: "app",
      service: "Sales/api/QuotaTransactionsQuery/all-QuotaTransaction",
    };
    this.renderGrid();
    this.emptyFileInRefs = this.$refs.file.files;
  },

  methods: {
    ...mapActions({
      importQuotasChargeExcel: "excel/importQuotasChargeTransactions",
    }),
    renderGrid() {
      setTimeout(() => {
        this.$refs.grid.renderGrid(1, true);
      }, 200);
    },
    handleFileUpload() {
      this.oldFileName = this.file.name;
      this.file = this.$refs.file.files[0];
      this.uploadedFileName = this.$refs.file.files[0].name;
      this.fileUploaded = true;
    },
    removeUploadFile() {
      this.file = "";
      this.chargeExpireDate = "";
      this.$refs.file.files = this.emptyFileInRefs;
      this.uploadedFileName = "";
      this.fileUploaded = false;
    },
    search() {
      this.$refs.grid.renderGrid(1, true);
    },
    uploadFile() {
      this.disabledBtn = true;
      if (this.oldFileName != this.file.name || this.isConfirmDuplicateData) {
        let formData = new FormData();
        formData.append("file", this.file);
        this.showLoading = true;
        this.importQuotasChargeExcel({
          file: formData,
          exDate: this.chargeExpireDate,
        }).then(() => {
          setTimeout(() => {
            this.$refs.grid.renderGrid(1, true);
          }, 3000);
        });
        setTimeout(() => {
          this.removeUploadFile();
          this.showLoading = false;
          this.isConfirmDuplicateData = false;
          this.disabledBtn = false;
        }, 1000);
      } else {
        this.$swal({
          title: this.testStr,
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "بلی",
          cancelButtonText: "خیر",
        }).then((result) => {
          if (result.value) {
            this.isConfirmDuplicateData = true;
            this.uploadFile();
          } else {
            setTimeout(() => {
              this.$refs.grid.renderGrid(1, true);
              this.showLoading = false;
              this.uploadedFileName = "";
              this.fileUploaded = false;
            }, 2000);
          }
        });
      }
    },
  },
};
</script>
